import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Activo } from '../../../core/modelos/activo';
import { FileManagerService } from '../file-manager/file-manager.service';
import { ActivosService } from '../activos/activos.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'fuse-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent {

  @Input() pantalla: string;
  @Input() item: Activo;
  @Input() idItem: number;
  @Input() idDashboard: number;
  @Input() isMobileNavigation: boolean;

  constructor(
    private router: Router,
    private fileManagerService: FileManagerService,
    private activosService: ActivosService,
    private notificaciones: NotificacionesService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.idDashboard && changes.idDashboard.currentValue) {
      this.idDashboard = +changes.idDashboard.currentValue;
    }

    if (changes.idItem && changes.idItem.currentValue) {
      this.idItem = +changes.idItem.currentValue;
      this.getActivo()
    }
  }

  getActivo() {
    this.activosService.getActivo(this.idItem).subscribe(
        data => {
            if (data.success) {
                this.item = data.items;
            } else {
                // CONTROLAR ERROR
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOObtenido);
            }
        },
        err => {
            // CONTROLAR ERROR
            this.notificaciones.errorServidor(err.status);
        }
    );
  }

  verDashboard(activoSeleccionado: Activo) {
    if (!activoSeleccionado) {
      this.router.navigate(['/general-dashboard']);
    } else {
      this.router.navigate(['/dashboard', activoSeleccionado.id]);
    }
  }

  goToDocs(seleccion: Activo) {
    if (seleccion) {
      if (seleccion.carpetaAWS) {
        this.fileManagerService.setCarpetaDestino(seleccion.carpetaAWS);
        this.router.navigate(['/docs', seleccion.id]);
      }
      else {
        // Mostrar error
        alert('El activo no tiene carpeta asociada');
      }
    } else {
      this.router.navigate(['/docs/raiz']);
    }
  }

  goToViewer(seleccion: Activo) {
    if (seleccion.enlace) {
      this.router.navigate(['/3d-viewer', { enlace: seleccion.enlace, id: seleccion.id }], { skipLocationChange: true });
    } else {
      this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos["3DViewer"].NoEnlace);
    }
  }

  goToTickets() {
      (this.idItem) ? this.router.navigate(['/tickets', this.idItem]) : this.router.navigate(['/tickets']);
  }

  goPowerBi(url: string, descripcion: string, idActivo: number, idDashboard: number) {
      this.idDashboard = idDashboard
      this.router.navigate(['/power-bi', { url: url, descripcion: descripcion, idActivo: idActivo, idDashboard: idDashboard}], { skipLocationChange: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/selector/selector.component.ts